import { Avatar, Box, Card, CardContent, Stack, Typography, alpha } from '@mui/material';

export const StatCard = ({ title, value, color, icon: Icon, subtitle, onClick, isActive }) => (
  <Card
    onClick={onClick}
    sx={{
      background: alpha('#1a1f2e', 0.8),
      border: `1px solid ${isActive ? color : alpha(color, 0.3)}`,
      borderRadius: 2,
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
      cursor: onClick ? 'pointer' : 'default',
      ...(isActive && {
        boxShadow: `0 0 12px ${alpha(color, 0.25)}`,
      }),
      '&:hover': {
        borderColor: alpha(color, onClick ? 0.7 : 0.5),
      },
    }}
  >
    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={1}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="caption"
            sx={{
              color: alpha('#fff', 0.5),
              textTransform: 'uppercase',
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h3"
            noWrap
            sx={{ color, fontWeight: 700, mt: 0.5, mb: 0.5 }}
          >
            {value}
          </Typography>
          {subtitle && (
            <Typography variant="caption" noWrap sx={{ color: alpha(color, 0.6), display: 'block' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <Avatar
          sx={{
            width: 48,
            height: 48,
            flexShrink: 0,
            bgcolor: alpha(color, 0.15),
            border: `1px solid ${alpha(color, 0.3)}`,
          }}
        >
          <Icon sx={{ fontSize: 24, color }} />
        </Avatar>
      </Stack>
    </CardContent>
  </Card>
);
